module.exports = __webpack_public_path__ + "static/media/UNIONBANK.0ca1bcca.svg";